export enum BuildingDocumentType {
  General = 0,
  Drawing = 1,
  ExteriorPhoto = 2,
  CommonAreasPhoto = 3,
  SalesDocument = 4,
}

export function BuildingDocumentTypeToString(documentType: BuildingDocumentType) {
  switch (documentType) {
    case BuildingDocumentType.Drawing:
      return 'DOCUMENT.DOCUMENT_TYPES.BUILDING.DRAWING';
    case BuildingDocumentType.ExteriorPhoto:
      return 'DOCUMENT.DOCUMENT_TYPES.BUILDING.EXTERIOR_PHOTO';
    case BuildingDocumentType.CommonAreasPhoto:
      return 'DOCUMENT.DOCUMENT_TYPES.BUILDING.COMMON_AREAS_PHOTO';
    case BuildingDocumentType.SalesDocument:
      return 'DOCUMENT.DOCUMENT_TYPES.BUILDING.SALES_DOCUMENT';

    default:
      return 'DOCUMENT.DOCUMENT_TYPES.BUILDING.GENERAL';
  }
}

export enum LeaseAgreementDocumentType {
  General = 0,
  Agreement = 1,
  Termination = 2,
  KeyReciept = 3,
}

export function LeaseAgreementDocumentTypeToString(documentType: LeaseAgreementDocumentType) {
  switch (documentType) {
    case LeaseAgreementDocumentType.Agreement:
      return 'DOCUMENT.DOCUMENT_TYPES.LEASE_AGREEMENT.AGREEMENT';
    case LeaseAgreementDocumentType.Termination:
      return 'DOCUMENT.DOCUMENT_TYPES.LEASE_AGREEMENT.TERMINATION';
    case LeaseAgreementDocumentType.KeyReciept:
      return 'DOCUMENT.DOCUMENT_TYPES.LEASE_AGREEMENT.KEY_RECIEPT';
    default:
      return 'DOCUMENT.DOCUMENT_TYPES.LEASE_AGREEMENT.GENERAL';
  }
}

export enum RentalObjectDocumentType {
  General = 0,
  InteriorPhoto = 1,
  FloorPlan = 3,
  SituationPlan = 4,
  InspectionReport = 5,
  Protocol = 6,
  Agreement = 7,
}

export function RentalObjectDocumentTypeToString(documentType: RentalObjectDocumentType) {
  switch (documentType) {
    case RentalObjectDocumentType.InteriorPhoto:
      return 'DOCUMENT.DOCUMENT_TYPES.RENTAL_OBJECT.INTERIOR_PHOTO';
    case RentalObjectDocumentType.FloorPlan:
      return 'DOCUMENT.DOCUMENT_TYPES.RENTAL_OBJECT.FLOOR_PLAN';
    case RentalObjectDocumentType.SituationPlan:
      return 'DOCUMENT.DOCUMENT_TYPES.SITUATION_PLAN';
    case RentalObjectDocumentType.InspectionReport:
      return 'DOCUMENT.DOCUMENT_TYPES.INSPECTION_REPORT';
    case RentalObjectDocumentType.Protocol:
      return 'DOCUMENT.DOCUMENT_TYPES.PROTOCOL';
    case RentalObjectDocumentType.Agreement:
      return 'DOCUMENT.DOCUMENT_TYPES.AGREEMENT';
    default:
      return 'DOCUMENT.DOCUMENT_TYPES.RENTAL_OBJECT.GENERAL';
  }
}

export enum LettingAdvertismentDocumentType {
  General = 0,
  InteriorPhoto = 1,
  CommonAreasPhoto = 2,
  ExteriorPhoto = 3,
  FloorPlan = 4,
  BuildingSalesDocument = 5,
}

export function LettingAdvertismentDocumentTypeToString(documentType: LettingAdvertismentDocumentType) {
  switch (documentType) {
    case LettingAdvertismentDocumentType.InteriorPhoto:
      return 'DOCUMENT.DOCUMENT_TYPES.LETTING_ADVERTISMENT.INTERIOR_PHOTO';
    case LettingAdvertismentDocumentType.ExteriorPhoto:
      return 'DOCUMENT.DOCUMENT_TYPES.LETTING_ADVERTISMENT.EXTERIOR_PHOTO';
    case LettingAdvertismentDocumentType.FloorPlan:
      return 'DOCUMENT.DOCUMENT_TYPES.LETTING_ADVERTISMENT.FLOOR_PLAN';
    case LettingAdvertismentDocumentType.BuildingSalesDocument:
      return 'DOCUMENT.DOCUMENT_TYPES.LETTING_ADVERTISMENT.SALES_DOCUMENT';
    case LettingAdvertismentDocumentType.CommonAreasPhoto:
      return 'DOCUMENT.DOCUMENT_TYPES.LETTING_ADVERTISMENT.COMMON_AREAS_PHOTO';
    default:
      return '';
  }
}

export enum ContactDocumentType {
  General = 0,
  Agreement = 1,
  WarningLetter = 2,
  DisturbanceLetter = 3,
  Photo = 4,
}

export function ContactDocumentTypeToString(documentType: ContactDocumentType) {
  switch (documentType) {
    case ContactDocumentType.General:
      return 'DOCUMENT.DOCUMENT_TYPES.GENERAL';
    case ContactDocumentType.Agreement:
      return 'DOCUMENT.DOCUMENT_TYPES.AGREEMENT';
    case ContactDocumentType.WarningLetter:
      return 'DOCUMENT.DOCUMENT_TYPES.WARNING_LETTER';
    case ContactDocumentType.DisturbanceLetter:
      return 'DOCUMENT.DOCUMENT_TYPES.DISTURBANCE_LETTER';
    case ContactDocumentType.Photo:
      return 'DOCUMENT.DOCUMENT_TYPES.PHOTO';
    default:
      return '';
  }
}

export enum PropertyDocumentType {
  General = 0,
  PlanDrawing = 1,
  FacadeDrawing = 2,
  SituationPlan = 3,
  InspectionReport = 4,
  Protocol = 5,
  Agreement = 6,
  Photo = 7,
}

export function PropertyDocumentTypeToString(documentType: PropertyDocumentType) {
  switch (documentType) {
    case PropertyDocumentType.General:
      return 'DOCUMENT.DOCUMENT_TYPES.GENERAL';
    case PropertyDocumentType.PlanDrawing:
      return 'DOCUMENT.DOCUMENT_TYPES.PLAN_DRAWING';
    case PropertyDocumentType.FacadeDrawing:
      return 'DOCUMENT.DOCUMENT_TYPES.FACADE_DRAWING';
    case PropertyDocumentType.SituationPlan:
      return 'DOCUMENT.DOCUMENT_TYPES.SITUATION_PLAN';
    case PropertyDocumentType.InspectionReport:
      return 'DOCUMENT.DOCUMENT_TYPES.INSPECTION_REPORT';
    case PropertyDocumentType.Protocol:
      return 'DOCUMENT.DOCUMENT_TYPES.PROTOCOL';
    case PropertyDocumentType.Agreement:
      return 'DOCUMENT.DOCUMENT_TYPES.AGREEMENT';
    case PropertyDocumentType.Photo:
      return 'DOCUMENT.DOCUMENT_TYPES.PHOTO';
    default:
      return '';
  }
}

export enum CompanyDocumentType {
  General = 0,
  PlanDrawing = 1,
  FacadeDrawing = 2,
  SituationPlan = 3,
  Agreement = 4,
  Photo = 5,
}

export function CompanyDocumentTypeToString(documentType: CompanyDocumentType) {
  switch (documentType) {
    case CompanyDocumentType.General:
      return 'DOCUMENT.DOCUMENT_TYPES.GENERAL';
    case CompanyDocumentType.PlanDrawing:
      return 'DOCUMENT.DOCUMENT_TYPES.PLAN_DRAWING';
    case CompanyDocumentType.FacadeDrawing:
      return 'DOCUMENT.DOCUMENT_TYPES.FACADE_DRAWING';
    case CompanyDocumentType.SituationPlan:
      return 'DOCUMENT.DOCUMENT_TYPES.SITUATION_PLAN';
    case CompanyDocumentType.Agreement:
      return 'DOCUMENT.DOCUMENT_TYPES.AGREEMENT';
    case CompanyDocumentType.Photo:
      return 'DOCUMENT.DOCUMENT_TYPES.PHOTO';
    default:
      return '';
  }
}

export enum InvoiceDocumentType {
  General = 0,
}

export function InvoiceDocumentTypeToString(documentType: InvoiceDocumentType) {
  switch (documentType) {
    case InvoiceDocumentType.General:
      return 'DOCUMENT.DOCUMENT_TYPES.GENERAL';
    default:
      return '';
  }
}
